import { render } from "./ControlePermissoesView.vue?vue&type=template&id=3668f556"
import script from "./ControlePermissoesView.vue?vue&type=script&lang=js"
export * from "./ControlePermissoesView.vue?vue&type=script&lang=js"

import "./ControlePermissoesView.vue?vue&type=style&index=0&id=3668f556&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__